import { render, staticRenderFns } from "./ConversationChat.vue?vue&type=template&id=ff2ea576&scoped=true&"
import script from "./ConversationChat.vue?vue&type=script&lang=js&"
export * from "./ConversationChat.vue?vue&type=script&lang=js&"
import style0 from "./ConversationChat.vue?vue&type=style&index=0&id=ff2ea576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2ea576",
  null
  
)

export default component.exports